import {Image, Text, TouchableOpacity, View} from 'react-native';
import styles from "./styles"
import {Images} from "../../config";
import Tooltip from "react-native-walkthrough-tooltip";
import {useState,useEffect} from "react";
import {Button} from "react-native-paper";
import {useSelector} from "react-redux";
import {Loader} from "rn-placeholder";

export default function PWAInstall({navigation,route}) {

    const [prompt,setPrompt] = useState(null)
    const [showToolTip,setShowToolTip] = useState(false)
    const [showInstallHint,setShowInstallHint] = useState(false)
    let latePrompt = useSelector(state=>state.event.event)

    useEffect(() => {
        if (latePrompt) {
            setPrompt(latePrompt)
        }
        setTimeout(() => {
            setShowToolTip(true)
            setShowInstallHint(true)
        }, 2500)
    },[latePrompt])
    const onInstallPress = (deferredPrompt) => {
        deferredPrompt.prompt()
        window.location.reload()
    }

    return(
        <View style={styles.container}>
            <View style={{alignItems: 'center'}}>
                {route.params.appData ? (
                    <Image source={route.params.appData.logo} style={styles.logo} resizeMode="contain" />
                ) : null}
                <Text style={styles.title}>Install App</Text>
                {route.params.doPrompt && !prompt ? (
                        <View style={{flexDirection: "column"}}>
                            <View style={{flex: 1}}>
                                <Text style={styles.instructions}>Click below to install the app</Text>
                                <Button title="Install"
                                        style={{backgroundColor: 'black'}}
                                >
                                    <Text style={styles.installText}>Install</Text>
                                </Button>
                            </View>
                        </View>
                     )
                    :
                    <></>
                }
                {route.params.doPrompt && prompt ? (
                        <View style={{flexDirection: "column"}}>
                            <View style={{flex: 1}}>
                                <Text style={styles.instructions}>Click below to install the app</Text>
                                <Button title="Install"
                                        onPress={() => onInstallPress(prompt)}
                                        style={{backgroundColor: 'black'}}
                                >
                                    <Text style={styles.installText}>Install</Text>
                                </Button>
                            </View>
                        </View>
                    )
                    :
                    <></>
                }
                {!route.params.doPrompt ? (
                    <View style={{flexDirection:"column"}}>
                        <View style={{flex:1}}>
                            <Text style={styles.instructions}>1) Press the Share button <Image source={Images.upload} style={styles.icons} resizeMode="contain" /></Text>
                        </View>
                        <View style={{flex:1}}>
                            <Text style={styles.instructions}>2) Scroll down to and tap "Add to Home Screen <Image source={Images.add} style={styles.icons} resizeMode="contain"  />"</Text>
                        </View>
                    </View>
                )
                    :
                    <></>
                }
            </View>
            {!route.params.doPrompt ? (
                <View style={{justifyContent: 'flex-end', flex: 1}}>
                    <Tooltip
                        isVisible={showToolTip}
                        content={<View style={{marginVertical: 10, alignItems: "center"}}>
                            <Text>Press the Share button</Text>
                            <Text><Image source={Images.upload} style={styles.icons} resizeMode="contain"/></Text>
                        </View>}
                        placement="top"
                        useInteractionManager={true}
                        disableShadow={true}
                        closeOnChildInteraction={false}
                        childContentSpacing={0}
                    >
                        <View>
                            <Text> </Text>
                        </View>
                    </Tooltip>
                </View>
                )
                : null
            }
        </View>
    )
}
